import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { SecondaryButton } from "Shared/Buttons";
import styled from "styled-components";
import WithOpen from "Shared/WithOpen";
import ArrowDownIcon from "src/components/icons/ArrowDown";
import { ApplicationStore } from "src/store";
import { updateCurrentDeal } from "src/store/actions/currentDeal";
import { getAccountDisclaimer } from "src/utils/account";
import { VehicleState } from "Types/state";
import "./ExploreMore.scss";
import ExploreMoreMenu from "./ExploreMoreMenu";

const Btn = styled(SecondaryButton)`
    font-size: 0.625em;
    letter-spacing: normal;
    outline: 0;
    padding: 0.75em 0.5em;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        font-size: 0.875em;
        padding: 0.5em;
    }

    svg {
        margin-left: 1em;
    }
`;

interface Props extends RouteComponentProps {
    continueDealAllowed: boolean;
    updateCurrentDeal: (vin: string) => void;
    vehicle: VehicleState;
    vin: string;
}

const ExploreMore = (props: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { exploreMoreCTAText } = props;
    const render = (isOpen: boolean, toggleOpen: any, close: any, open: any) => {
        return (
            <div id="ExploreMore">
                <Btn onClick={open}>
                    {exploreMoreCTAText} <ArrowDownIcon />
                </Btn>

                {isOpen && <ExploreMoreMenu {...props} onClose={close} />}
            </div>
        );
    };

    return <WithOpen render={render} />;
};

const TRANSLATION_KEY = "MyGarage.TableCompare.VehicleHeader.ExploreMoreMenu";

function mapStateToProps({ account }: ApplicationStore) {
    return {
        exploreMoreCTAText: getAccountDisclaimer(account)("garage_explore_more_cta")(`${TRANSLATION_KEY}.btnContent`),
    };
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({ updateCurrentDeal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExploreMore));
